import { connect } from 'react-redux';
import { getPurchaseHistory, resetMeta, resetPage } from '../../actions/PurchaseHistoryPage';
import PurchaseHistoryPage from './PurchaseHistoryPage';

const mapsStateToProps = state => ({
	purchaseHistoryPageProps: state.purchaseHistoryPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getPurchaseHistory() {
		dispatch(getPurchaseHistory());
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(PurchaseHistoryPage);
